module.exports = __webpack_public_path__ + "static/media/icon-hb-money-bg.353d391c.svg";